<template>
  <v-menu ref="menu1"
    v-model="menu1"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto">
    <template v-slot:activator="{ on }">
      <v-text-field class="my-0 py-1"
        placeholder="DD/MM/YYYY"
        autocomplete="off"
        :prepend-icon="prependIcon"
        v-model="selected"
        single-line
        :required="required"
        :disabled="disabled"
        @input="$emit('input', formatDateToDisplay($event))"
        @blur="date = parseDate(value)"
        v-on="on"
        :dense="dense"
        :outlined="outlined"
        readonly
        value
        @focus="handleFocus"
      />
    </template>
    <v-date-picker
      v-model="date"
      @input="onDateSelect"
      no-title
      :max="maxToDate"
      :min="minToDate"
    />
  </v-menu>
</template>

<script>
import moment from 'moment'

export default {
  name: 'CustomDatePicker',
  props: {
    value: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    maxToDate: {
      type: String,
      default: null
    },
    minToDate: {
      type: String,
      default: null
    },
    prependIcon: {
      type: String,
      default: null
    },
    dense: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      menu1: null,
      date: null
    }
  },

  computed: {
    selected: {
      get () {
        return this.formatDateToDisplay(this.value)
      },
      set (value) {
        this.$emit('input', this.formatDateToValue(value))
      }
    }
  },

  methods: {
    formatDateToDisplay (date) {
      // Convert the date to 'DD/MM/YYYY' for displaying in the input
      return date ? moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY') : null
    },
    formatDateToValue (date) {
      // Convert the date to 'YYYY-MM-DD' to store in the data model
      return date ? moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null
    },
    parseDate (date) {
      if (!date) {
        return null
      }
      // Parse 'DD/MM/YYYY' format to moment object
      return date
      // return moment(date, 'DD/MM/YYYY').toDate()
    },
    onDateSelect (date) {
      // Convert selected date from picker to 'YYYY-MM-DD' format
      this.date = this.formatDateToValue(moment(date).format('DD/MM/YYYY'))
      this.menu1 = false
      this.$emit('input', this.formatDateToValue(moment(date).format('DD/MM/YYYY')))
    },
    handleFocus (event) {
      this.$emit('focus', event)
    }
  }
}
</script>
